import React from 'react';

const ConfirmBox = ({options, isOpen, onClose, onConfirm, onCancel}) => {
  const {text, confirm, cancel} = options;
  return (
    <div className="confirm-box-container" style={{display: isOpen ? "block" : "none"}}>
      <div className="confirm-box-content">
        <div className="confirm-box flipInX">
          <div className="confirm-box-header">
            <p>{text}</p>
          </div>
          <span className="confirm-box-close" onClick={onClose}/>
          <div className="confirm-btn">
            <button onClick={onConfirm}>{confirm}</button>
            <button onClick={onCancel}>{cancel}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmBox;
